export default __webpack_public_path__ + "static/media/chart.f279a052.svg";